// Auth route — `/auth/account-deleted` (US-014, Wave B6).

import { createRoute } from '@tanstack/react-router';

import { AccountDeletedPage } from '@/features/auth/AccountDeletedPage';

import { Route as RootRoute } from '../__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/auth/account-deleted',
  component: AccountDeletedPage,
});
